<ng-container *ngIf="previaCarga">
  <ng-container *ngIf="logoCGO5">
    <iframe [src]="urlSafe" width="100%" height=""></iframe>
  </ng-container>

  <ng-container *ngIf="!logoCGO5">
    <ng-container *ngIf="!contenidoExterno; else contExterno">
      <ng-container *ngIf="infoVideo.enable">
        <video [src]="infoVideo.video" autoplay [loop]="infoVideo.loop" [muted]="infoVideo.mute" class="iframeExt"></video>
      </ng-container>
      <ng-container *ngIf="!infoVideo.enable">
        <div class="collage">
          <div class="columna_4" [ngClass]="{'columna_5':cincoColumnas, 'columna_1':unaColumna}" *ngFor="let columna of columnas;">
            <img *ngFor="let imagen of columna" [src]="imagen.ruta" alt="" [@animate]="{value:'*',params:{delay:imagen.delay, y:'25px'}}" class="imagenCollage" [ngClass]="{'imagenGris':configHome.filtroGris && !imagen.branding, 'imagenColor':!configHome.filtroGris}">
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #contExterno>
      <iframe [src]="urlExterna" width="100%" height=""></iframe>
    </ng-template>
  </ng-container>
</ng-container>
